export enum IntegrationRootFolderIDs {
  DEFAULT = 'DEFAULT',
  CODELESS_AUTOMATION_TOOL = 'CODELESS_AUTOMATION_TOOL',
  ALM_TEST_MANAGEMENT ='ALM_TEST_MANAGEMENT',
  CI_CD_PINELINE = 'CI_CD_PINELINE',
  COLLABORATION = 'COLLABORATION',
  MOBILE_DEVICE_TESTING = 'MOBILE_DEVICE_TESTING',
  TESTING_FRAMEWORK = 'TESTING_FRAMEWORK'
}
